/*
 * OpenAPI definition
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: v0
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 *
 * Swagger Codegen version: 3.0.58
 *
 * Do not edit the class manually.
 *
 */
import ApiClient from '../ApiClient';
import AqaQualityDefinition from './AqaQualityDefinition';

/**
 * The AqaQDResponse model module.
 * @module model/AqaQDResponse
 * @version v0
 */
export default class AqaQDResponse {
  /**
   * Constructs a new <code>AqaQDResponse</code>.
   * @alias module:model/AqaQDResponse
   * @class
   */
  constructor() {
  }

  /**
   * Constructs a <code>AqaQDResponse</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:model/AqaQDResponse} obj Optional instance to populate.
   * @return {module:model/AqaQDResponse} The populated <code>AqaQDResponse</code> instance.
   */
  static constructFromObject(data, obj) {
    if (data) {
      obj = obj || new AqaQDResponse();
      if (data.hasOwnProperty('success'))
        obj.success = ApiClient.convertToType(data['success'], 'Boolean');
      if (data.hasOwnProperty('message'))
        obj.message = ApiClient.convertToType(data['message'], 'String');
      if (data.hasOwnProperty('qualityDefinition'))
        obj.qualityDefinition = AqaQualityDefinition.constructFromObject(data['qualityDefinition']);
      if (data.hasOwnProperty('successful'))
        obj.successful = ApiClient.convertToType(data['successful'], 'Boolean');
    }
    return obj;
  }
}

/**
 * @member {Boolean} success
 */
AqaQDResponse.prototype.success = undefined;

/**
 * @member {String} message
 */
AqaQDResponse.prototype.message = undefined;

/**
 * @member {module:model/AqaQualityDefinition} qualityDefinition
 */
AqaQDResponse.prototype.qualityDefinition = undefined;

/**
 * @member {Boolean} successful
 */
AqaQDResponse.prototype.successful = undefined;

